module.exports = __webpack_public_path__ + "img/09.bd5192b6.svg";